import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Components } from '../../constants';
import { StoryblokComponent } from 'storyblok-js-client';
import { NUMBER_40 } from '~shared/constants';
import { Params } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { CatalogState } from '~app/modules/catalog/store';
import { getQueryParams } from '~app/core/store';
import { shareReplay, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { InputsType } from 'ng-dynamic-component';

@Component({
  selector: 'app-storyblok-seo-content-wrapper',
  templateUrl: './seo-content-wrapper.component.html',
})
export class SeoContentWrapperComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject();

  @Input() content: Array<StoryblokComponent<string>>;
  @Input() isMobile: boolean;
  @Input() _editable: string;

  queryParams: Params;

  get isFirstPage(): boolean {
    return !this.queryParams.offset || +this.queryParams.offset < NUMBER_40;
  }

  readonly COMPONENTS = Components;

  constructor(private store$: Store<CatalogState>) {}

  ngOnInit(): void {
    this.initializeQueryParams();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  buildInputs(blokInputs: InputsType): InputsType {
    return {...blokInputs, isMobile: this.isMobile}
  };

  initializeQueryParams(): void {
    this.store$
      .pipe(select(getQueryParams, takeUntil(this.unsubscribe$)), shareReplay(1))
      .subscribe((queryParams: Params) => {
        this.queryParams = queryParams;
      });
  }
}
